import tw, { styled } from "twin.macro"

export const Wrapper = styled.div`
  ${tw`mb-3-2`}
  button {
    ${tw`px-1`}
  }
`

export const Message = styled.p<MessageProps>`
  ${tw`block md:inline-block text-14 leading-1.2 tracking-5 font-medium py-0-4 px-0-6 w-full md:w-auto mb-2 uppercase`}
  ${({ red }) => (red === "true" ? tw`text-red bg-transparent text-left` : tw`bg-beige text-center`)}
`

type MessageProps = {
  red: "true" | "false"
}
